import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TApiPaginatedRequest } from "../../../AbstractApiClient/IApiRequest";
import { TApiPaginatedResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetLaborPostersRequestSchema,
  TGetLaborPostersResponseSchema,
} from "./getLaborPosters.schema";

export const getLaborPosters = (axios: IAxiosInstance) => {
  return async (
    params: TApiPaginatedRequest<TGetLaborPostersRequestSchema>
  ) => {
    const response = await axios.noRetry.get<
      TApiPaginatedResponse<TGetLaborPostersResponseSchema>
    >("/labor-posters", {
      params,
    });
    return response.data;
  };
};
